import styled from "@emotion/styled";

export const Sup = styled.span`
  font-size: 0.7em;
  vertical-align: 0.3em;
`;
